export default {
  indicators: [],
  indicator: null,
  pagination: {}
};
